import React,{useEffect, useState} from "react";
import styles from './Bienvenido.module.css';
import { useDispatch, useSelector } from "react-redux";
import {  CODEaction } from "../../store/actions.js"; 
import {  useNavigate } from "react-router-dom";
import axios from "axios";
import ReactGA from 'react-ga';

import LogoPrincipal from "./assets/LogoPrincipalHome.png";
import LogoConcierto from "./assets/CoollogoConciertos.png";
import Gaseosas from "./assets/Gaseosas.png";
import LogoIsm from "./assets/LogoISM.png";
import GaseosasMobile from "./assets/GaseosasMobile.png";
import LogoISMMobile from "./assets/LogoISMMobile.png";


import { Link } from "react-router-dom";


const Bienvenido2 = () => {

  const dispatch = useDispatch()
  const dni = useSelector((state) => state.dni);
  const [nombre, setNombre] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [Codigo, setCodigo] = useState("");
  
  const navigate = useNavigate();

  // const Nombres = nombre.split(" ");
  // const PrimerNombre = Nombres[0];

  const envioCODE = () => {
    dispatch(CODEaction(Codigo)); // Despacha la acción de decremento
  };


  const InfoName = async () => {
    try {
      const resp = await axios.put("https://winged-rain-production.up.railway.app/DataUsuario" , {
        DNI : dni
      })
      const nombreCompleto = resp.data.nombre;
      console.log('hola');
      // console.log( nombreCompleto)

      // Divide el nombre completo en palabras
      const palabrasNombre = nombreCompleto.split(" ");
  
      // Obtiene el primer nombre
      const primerNombre = palabrasNombre[0];
  
      // Establece el primer nombre en el estado
      setNombre("Daniel");
      setIsLoading(false)

    } catch (error) {
       setNombre("Daniel");
       console.log(error)
    }

  }

  const redirect = async () => {
    try {
        navigate("/");
    } catch (error) {
      console.log(error);
    }
  };
  
  useEffect(() => {
  
    ReactGA.pageview('/Bienvenido');


    document.title = "Bienvenido: Destapa y gana conciertos gratis por un año / Cool Fresh, una marca de ISM";

    // Actualizar la descripción de la página
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Escribe el código para destapar y ganar conciertos gratis por un año con Cool Fresh, una marca de ISM");
    }
    InfoName()
  },[]);

  const handleInputtCodigo = (event) => {
    const newValue = event.target.value;
    setCodigo(newValue);
    // const inputValue = event.target.value;

    // const regex = /^[A-Z0-9]*$/;
    // if (regex.test(inputValue) || inputValue === "") {
    //   setCodigo(inputValue);
    // }
  };


  return (
    <div className={styles.Home}>
     {/* <Link  to={'/prueba'} style={{margin:'0 auto'}}>  */}
      <img onClick={redirect} src={LogoPrincipal} alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' style={{zIndex:'200'}} className={styles.LogoPrincipal}></img>
     {/* </Link>  */}

     <div className={styles.lefDiv}>
{isLoading ? (
      //   <div className={styles.divTexto}>
      //      <h2 className={styles.cargando} style={{marginBottom:'30px'}}>Cargando...</h2>
      //    </div>
     <div className={styles.divTexto}>
          <h2>¡BIENVENIDO, {nombre?.toUpperCase()}!</h2>
          <p>
            Ingresa el código que encontraste
            <br className={styles.brMobile} /> en la tapa de tu COOL FRESH <br></br>
            y acumula chances para ganar.
          </p>
        </div>
  
       ) : (
        <div className={styles.divTexto}>
          <h2>¡BIENVENIDO, {nombre?.toUpperCase()}!</h2>
          <p>
            Ingresa el código que encontraste
            <br className={styles.brMobile} /> en la tapa de tu COOL FRESH <br></br>
            y acumula chances para ganar.
          </p>
        </div>
      )} 


       <input 
         type="text" placeholder="ESCRIBE EL CÓDIGO AQUÍ." 
         className={styles.inputCode}
         value={Codigo} 
         onChange={handleInputtCodigo}
         style={{zIndex:'100'}}
         >
       </input>




        <Link to={'/Resultado'}>
           <button onClick={() => {envioCODE()}} className={styles.button}>VALIDAR</button>
        </Link>   
        </div>


      <img src={LogoConcierto} className={styles.LogoConcierto} alt='destapa_gana_conciertos_gratis_cool_fresh_ISM'></img>
      <img src={Gaseosas} className={styles.Gaseosas} alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' ></img>
      <img src={GaseosasMobile} className={styles.GaseosasMobile} alt='destapa_gana_conciertos_gratis_cool_fresh_ISM'></img>
      <img src={LogoIsm} className={styles.LogoIsm}alt='destapa_gana_conciertos_gratis_cool_fresh_ISM' ></img>
      <img src={LogoISMMobile} className={styles.LogoISMMobile}alt='destapa_gana_conciertos_gratis_cool_fresh_ISM'></img>
    </div>
  );
};

export default Bienvenido2;
